(function () {
  'use strict';
  function valid(split,limit=28,full=false) {
    return Array.isArray(split)&&split.length===4&&split.every(n=>Number.isInteger(n)&&n>=0&&n%7===0)&&split.reduce((a,b)=>a+b,0)<=limit&&(!full||split.reduce((a,b)=>a+b,0)===limit);
  }
  function sum(boxes) {
    if(!Array.isArray(boxes)||boxes.length!==2||boxes.some(box=>!valid(box))) throw new Error('Invalid boxes');
    return boxes[0].map((n,i)=>n+boxes[1][i]);
  }
  function partition(split) {
    if(!valid(split,56)) throw new Error('Invalid 56-bar split');
    const boxes=[split.map(n=>Math.floor(n/14)*7),split.map(n=>Math.floor(n/14)*7)];
    split.forEach((n,i)=>{if(n%14){const index=boxes[0].reduce((a,b)=>a+b,0)<=boxes[1].reduce((a,b)=>a+b,0)?0:1;boxes[index][i]+=7;}});
    if(boxes.some(box=>!valid(box))) throw new Error('Invalid partition');
    return boxes;
  }
  function same(boxes) {return boxes[0].every((n,i)=>n===boxes[1][i]);}
  function resize(split, oldSize, size, soldOut=[false,false,false,false]) {
    if(![14,28,56].includes(oldSize)||![14,28,56].includes(size)||!valid(split,oldSize)||!Array.isArray(soldOut)||soldOut.length!==4) throw new Error('Invalid size split');
    const available=[0,1,2,3].filter(i=>!soldOut[i]);
    if(!available.length) throw new Error('No available flavours');
    split=split.map((n,i)=>soldOut[i]?0:n);
    const selected=split.reduce((a,b)=>a+b,0);
    if(selected<=size) {
      const next=[...split];
      for(let n=selected;n<size;n+=7) {
        const i=available.reduce((best,i)=>next[i]<next[best]?i:best,available[0]);
        next[i]+=7;
      }
      return next;
    }
    const active=split.map((n,i)=>({n,i})).filter(x=>x.n).sort((a,b)=>b.n-a.n||a.i-b.i).slice(0,size===14?2:4).map(x=>x.i);
    const retained=active.reduce((n,i)=>n+split[i],0),next=[0,0,0,0];
    active.forEach(i=>next[i]=7);
    for(let n=active.length*7;n<size;n+=7) {
      const i=active.reduce((best,i)=>split[i]*size/retained-next[i]>split[best]*size/retained-next[best]?i:best,active[0]);next[i]+=7;
    }
    return next;
  }
  const api={valid,sum,partition,same,resize};
  if(typeof module!=='undefined'&&module.exports) module.exports=api;
  else window.EBBoxSplit=api;
})();
